<template>
  <div>
    <canvas
      ref="canvas"
      clas="d-none"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: 'LumaCalculator',
  props: {
    imageSource: {
      type: [
        File,
        Blob,
        String,
      ],
      required: true,
    },
    maxSize: {
      type: Number,
      default: 100,
    },
    swiperRef: Object,
  },
  watch: {
    imageSource: {
      immediate: true,
      handler(source) {
        if (source) {
          this.calculateLuma(source)
        } else {
          this.$emit('luma-calculated', 256)
        }
      },
    },
  },
  methods: {
    calculateLuma(source) {
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      const swiper = this.swiperRef

      img.onload = () => {
        if (swiper && swiper.height) {
          // If the image is wider than swiper container, return 256 since we need dark indicators then
          const widerThan = swiper && img.width > swiper.width
          // If the image is lower than the area minus 2 times the disctance to indicators, return 256 since we need dark indicators then
          const height = widerThan ?
              img.height / (img.width / swiper.width)
              : img.height
          const lowerThan = swiper && height < swiper.height - 72
          if (lowerThan) {
            this.$emit('luma-calculated', widerThan ? 200 : 222)
            return
          }
        }

        const canvas = this.$refs.canvas
        // Use willReadFrequently for faster getImageData operations
        const ctx = canvas.getContext('2d', { willReadFrequently: true })

        // Scale the image down if necessary
        const scale = Math.min(
            this.maxSize / img.width, this.maxSize / img.height, 1)
        canvas.width = img.width * scale
        canvas.height = img.height * scale

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        try {
          // Define the target region: 50x12 px, horizontally centered, 24px from the bottom
          const regionWidth = 50
          const regionHeight = 12
          const xStart = Math.floor((
                                        canvas.width - regionWidth
                                    ) / 2)
          const yStart = Math.floor(canvas.height - 24 - regionHeight)

          // Check if the region fits inside the canvas
          if (
              xStart < 0 || yStart < 0 ||
              xStart + regionWidth > canvas.width ||
              yStart + regionHeight > canvas.height
          ) {
            this.$emit('luma-calculated', 255)
            return
          }

          // Get pixel data for the region
          const imageData = ctx.getImageData(
              xStart, yStart, regionWidth, regionHeight).data

          let lumaSum = 0
          let sampleCount = 0
          const skip = 2 // Subsampling: every 2nd pixel in x and y

          for (let y = 0; y < regionHeight; y += skip) {
            for (let x = 0; x < regionWidth; x += skip) {
              const idx = (
                              y * regionWidth + x
                          ) * 4
              const r = imageData[idx]
              const g = imageData[idx + 1]
              const b = imageData[idx + 2]
              const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b
              lumaSum += luma
              sampleCount++
            }
          }

          // Calculate and emit the average luma
          const averageLuma = lumaSum / sampleCount
          this.$emit('luma-calculated', averageLuma)
        } catch (e) {
          // On error, emit 256
          this.$emit('luma-calculated', 20)
        }
      }

      img.onerror = () => {
        // On image load error, emit 256
        this.$emit('luma-calculated', 30)
      }

      // Set image source
      if (typeof source === 'string') {
        img.src = source
      } else {
        img.src = URL.createObjectURL(source)
      }
    },
  },
}
</script>
